import { JOURNEY_ROUTES } from '../../../core/constants/journey-routes';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToolbarModule } from 'primeng/toolbar';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { IItemNavbar } from './navbar-item.model';
import { navbar } from './navbar-items';
import { AuthenticationService } from '../../../core/auth/authentication.service';
import { SpinnerService } from '../../../core/ui/spinner.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { URL_PAGO } from '../../../core/constants/globals';
import { PaymentPortalModalComponent } from '../payment-portal-modal/payment-portal-modal.component';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule, NgOptimizedImage, ToolbarModule, TieredMenuModule, PaymentPortalModalComponent],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit, OnDestroy {
  readonly journeyRoutes = JOURNEY_ROUTES;
  items_navbar: Array<IItemNavbar> = navbar;
  show: boolean = false;
  show_menu: boolean = false;
  index: number = 0;
  URL_PAGO_MINI_RP: string = URL_PAGO.MINI_RP;
  URL_PAGO_PLP: string = URL_PAGO.PLP;
  logoNavbar =
    'https://d2kkzfskpa3qm4.cloudfront.net/imagenes/Logo-Rayo-2024.webp';

  auth: { login: boolean; subscription: Subscription } = {
    login: false,
    subscription: Subscription.EMPTY,
  };

  menuPayment!: MenuItem[];
  menuItems!: MenuItem[];
  showPaymentModal: boolean = false;

  @Input() toogle: boolean = false;
  @Output() isToogle = new EventEmitter<boolean>(false);

  constructor(
    private readonly authenticationService: AuthenticationService,
    public spinner: SpinnerService,
  ) {
    this.auth.subscription = this.authenticationService
      .onMessage()
      .subscribe((message) => {
        this.auth.login = message.estado === 'login';
      });
  }

  ngOnInit() {
    this.getDataFromLocalStorage();
    this.loadItemsNavbarResponsive();
  }

  ngOnDestroy(): void {
    this.auth.subscription.unsubscribe();
  }

  getDataFromLocalStorage = () => {
    if (localStorage.getItem('contacto')) {
      this.auth.login = true;
    }
  };

  goToPagar = () => {
    this.showPaymentModal = true;
  };

  hidePaymentModal = () => {
    this.showPaymentModal = false;
  };

  loadItemsNavbarResponsive = () => {
    this.menuItems = [
      {
        label: '¿Quiénes somos?',
        styleClass: 'font-medium uppercase text-sm',
        items: [
          {
            label: 'Nuestra historia',
            styleClass: 'border-t-2 border-amber-500 mt-0',
            routerLink: 'quienes-somos',
          },
          {
            label: 'Misión',
            routerLink: 'quienes-somos',
            fragment: 'mision-vision',
          },
          {
            label: 'Visión',
            routerLink: 'quienes-somos',
            fragment: 'mision-vision',
          },
        ],
      },
      {
        label: 'Servicios',
        styleClass: 'font-medium uppercase text-sm',
        items: [
          {
            label: 'Préstamos al instante',
            styleClass: 'border-t-2 border-amber-500',
            routerLink: 'servicios',
          },
        ],
      },
      {
        label: 'Beneficios',
        styleClass: 'font-medium uppercase text-sm',
        routerLink: 'beneficios',
      },
      {
        label: 'Testimonios',
        styleClass: 'font-medium uppercase text-sm',
        routerLink: 'testimonios',
      },
      {
        label: 'Blog',
        styleClass: 'font-medium uppercase text-sm',
        routerLink: 'blog',
      },
      {
        label: 'Ayuda',
        styleClass: 'font-medium uppercase text-sm',
        items: [
          {
            label: 'Preguntas frecuentes',
            styleClass: 'border-t-2 border-amber-500 mt-0',
            routerLink: 'ayuda',
          },
        ],
      },
      {
        label: 'Pagar',
        icon: 'pi pi-dollar',
        iconClass: 'icon-sm',
        styleClass:
          'font-medium uppercase bg-orange-primary text-sm style-custom',
        command: () => {
          this.goToPagar();
        },
      },
      {
        label: 'Pedir mi crédito ya',
        icon: 'pi pi-arrow-right',
        iconClass: 'icon-xs',
        styleClass:
          'font-medium uppercase bg-yellow-primary text-sm style-custom style-custom-other',
        routerLink: '/',
        fragment: 'calculadora',
      },
    ];
  };
  showItems(event: any, index: number) {
    this.index = index;
    this.show = true;
  }

  hiddenItems(event: any, index: number) {
    this.index = index;
    this.show = false;
  }

  handleToogle(event: any) {
    this.toogle = !this.toogle;
    this.isToogle.emit(this.toogle);
  }
}
